/* eslint-disable prettier/prettier */
/* eslint-disable react/no-unescaped-entities */
import React, { useEffect } from "react";
// import logo from "../../../assets/images/logo/unique.png";
import "./Index.scss";
// import style from "../LandingPage/index.module.scss";
// import { IoCallOutline, IoLocationOutline } from "react-icons/io5"
// import { BsWhatsapp, BsFacebook, BsTwitter, BsLinkedin } from "react-icons/bs"
import { Link } from "react-router-dom";
import logo from "../../../assets/images/mindtech-logo.png";

const CancellationAndRefund = () => {
  useEffect(() => {
    window.scrollTo({ top: 0, left: 0, behavior: "smooth" });
  }, []);
  return (
    <div id="policycontainer">
      <div id="header">
        <img src={logo} alt="" />
      </div>
      <div id="wrapper">
        <p id="contentheader">Cancellation & Refund Policy</p>
        <div id="contentspeader"></div>
        <p id="updated-date">Last updated on July 1st 2024</p>
        <p className="content-text">
          Mind Tech believes in helping its customers as far as possible, and has therefore a
          liberal cancellation policy. Under this policy:
        </p>

        <ul>
          <li className="content-text list-text">
            Cancellations will be considered only if the request is made immediately after placing
            the order.
          </li>
          <li className="content-text list-text">
            In case of any Refunds approved by the Mind Tech, it’ll take 3-5 days for the refund to
            be processed to the end customer..
          </li>
        </ul>
      </div>
      <section></section>
    </div>
  );
};

export default CancellationAndRefund;
